var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4951 2.22964C19.2661 1.35201 18.5914 0.660807 17.7347 0.426238C16.182 0 9.95557 0 9.95557 0C9.95557 0 3.72921 0 2.17642 0.426238C1.31976 0.660844 0.645057 1.35201 0.416063 2.22964C0 3.82041 0 7.1394 0 7.1394C0 7.1394 0 10.4584 0.416063 12.0492C0.645057 12.9268 1.31976 13.5892 2.17642 13.8238C3.72921 14.25 9.95557 14.25 9.95557 14.25C9.95557 14.25 16.1819 14.25 17.7347 13.8238C18.5914 13.5892 19.2661 12.9268 19.4951 12.0492C19.9111 10.4584 19.9111 7.1394 19.9111 7.1394C19.9111 7.1394 19.9111 3.82041 19.4951 2.22964ZM7.91919 10.1528V4.12601L13.1232 7.13947L7.91919 10.1528Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8df8144b.svg";
export { ForwardRef as ReactComponent };